import React, { FC } from 'react'

import { IconWaterproofProps } from './IconWaterproof.types'
import * as Styled from './styles/IconWaterproof.style'

import { nonThemeableRules } from '../../ruleSet'

const IconWaterproof: FC<IconWaterproofProps> = ({
  size = nonThemeableRules.defaultSize as number as IconWaterproofProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconWaterproofProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M82.95 1.29a4 4 0 0 0-6 .09c-.47.55-11.65 13.45-15.34 18C50.32 33.38 24 69.32 24 101.24 24 134.19 48.6 160 80 160a54.74 54.74 0 0 0 40.18-17A58.94 58.94 0 0 0 136 102.13C136 59.55 85.11 3.65 82.95 1.29zM80 152c-26.92 0-48-22.3-48-50.76 0-9.78 3.49-36.85 35.85-76.8 2.45-3 8.5-10.08 12.18-14.35 10.9 12.65 48 58.18 48 92C128 130.56 107.36 152 80 152z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconWaterproof
